import { render, staticRenderFns } from "./EditStatus.vue?vue&type=template&id=4b97c350&scoped=true"
import script from "./EditStatus.vue?vue&type=script&lang=js"
export * from "./EditStatus.vue?vue&type=script&lang=js"
import style0 from "./EditStatus.vue?vue&type=style&index=0&id=4b97c350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_255d5a8a54575e72ac5a6ee47e553c82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97c350",
  null
  
)

export default component.exports